import { render, staticRenderFns } from "./bandLoginPaw.vue?vue&type=template&id=c80c2508&scoped=true"
import script from "./bandLoginPaw.vue?vue&type=script&lang=js"
export * from "./bandLoginPaw.vue?vue&type=script&lang=js"
import style0 from "./bandLoginPaw.vue?vue&type=style&index=0&id=c80c2508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80c2508",
  null
  
)

export default component.exports